export default "__VITE_ASSET__D4Qh8OBe__"